
import { Box, Container, DialogActions, IconButton, InputBase } from "@mui/material";
import CardServices from '../cardServices';
import { useEffect, useState } from "react";
import api from '../../../services/api';
import RegisterAccess from '../../../utils/registerAccess';
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingShort from "../../../load/loadingShort";
import { useNavigate } from "react-router-dom";
import MessageError from "../../../messages/messageError";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";

// import { useSelector } from 'react-redux';


interface MenuState {
  analise: number;
  finalizado: number;
  indeferido: number;
  dadg: number;
  dasg: number;
  dcqmts: number;
  dcitms: number;
  dftec: number;
  dgase: number;
  dgssa: number;
  dlif: number;
  dmts: number;
  servicosGerais: number;
  // secretariaDirectorGeral: number;
  // secretariaDirectorAdjAreaAdmin/dadg: number;
  // secretariaDirectorAdjAreaTecnica: number;
  // chefeDepartamento: number;
  // directorAdjAreaAdmin/dadg: number;
  directorGeral: number;
  reclamacoes: number; 
  // directorAdjAreaTecnica: number;

}

type MenuProps = {
  styles: string
  children?: React.ReactNode
}

export default function MenuExpediente({ styles, children }: MenuProps) {
  // const user = useSelector(state => state.account.user);
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [search, setSearch] = useState("");
  const [messageError, setMessageError] = useState("");
  const [loadMenu, setLoadMenu] = useState<boolean>(true)
  const [menu, setMenu] = useState<MenuState>({
    analise: 0,
    finalizado: 0,
    indeferido: 0,
    dadg: 0, //Apoio ao Director Geral
    dasg: 0, //Administração e Serviços Gerais
    dcqmts: 0, //Controlo de qualidade de Medicamentos e Tecnologias de Saúde
    dcitms: 0, //Comunicação, Inovação Tecnológica e Modernização dos Serviços
    dftec: 0, //Farmacovigilância, Tecnovigilância e Ensaios Clínicos
    dgase: 0,
    dgssa: 0,
    dlif: 0, //Licenciamento e Inspecção Farmacêutica
    dmts: 0, //Medicamentos e Tecnologias de Saúde
    servicosGerais: 0, 
    // secretariaDirectorGeral: 0,
    // secretariaDirectorAdjAreaAdmin/dadg: 0,
    // secretariaDirectorAdjAreaTecnica: 0,
    // chefeDepartamento: 0,
    // directorAdjAreaAdmin/dadg: 0,
    directorGeral: 0,
    reclamacoes: 0,
    // directorAdjAreaTecnica: 0,

  })

  useEffect(() => {
    api.get(`/menu/expediente`)
      .then(response => {
        setMenu(response.data);
      }).catch(error => {

      }).finally(() => setLoadMenu(false))

  }, [])

  const searchExpediente = async (e: any) => {
    e.preventDefault();
    setMessageError('')
    setLoad(true);

    try {
      const response = await api.post(`/expediente/search-by-number`, {
        numero: search,
        // status: status, // 
      });
      // console.log(response)
      navigate(`/admin/expediente/view/${response.data.expediente?._id}`)
    } catch (error) {
      // console.error(error);
      // setMessageError(error?.response?.data.message);
      setMessageError('Expediente não encontrado!');
    } finally {
      setLoad(false);
    }
  };

  return (
    <Container>
      <RegisterAccess page={'expediente'} />
      {messageError && <MessageError message={messageError} />}

      <DialogActions sx={{ padding: 0 }}>
        <form
          onSubmit={searchExpediente}
          style={{
            width: '30%',
            border: "1px solid #85287e",
            borderRadius: 10,
            display: "flex",
            padding: 3,
            // flexWrap: "wrap",
            marginRight: 20,
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            // autoFocus
            type="number"
            placeholder="Procurar pelo  número de registo"
            inputProps={{ "aria-label": "Filtrar lista" }}
            onChange={(e) => setSearch(e.target.value)}
          />

          <IconButton type="submit" aria-label="search">
            {load ? <LoadingShort text={''} /> : <SearchOutlinedIcon />}
          </IconButton>
        </form>
      </DialogActions>


      <Box className={styles}>
        <CardServices funcao='Técnico' load={loadMenu} count={menu.analise} icone={'/icones/expediente/entrada.svg'} nomeService={'Registos'} link={'/admin/dadg/expediente/area/Análise?page=1'} />
        {/* <CardServices load={loadMenu} count={menu.finalizado} icone={'/icones/expediente/saida.svg'} nomeService={'Saídas Utentes-Instituições'} link={'/admin/dadg/expediente/saidas?page=1'} /> */}
        <CardServices load={loadMenu} count={menu.indeferido} icone={'/icones/solictacoesReprovadas.svg'} nomeService={'Indeferidos'} link={'/admin/dadg/expediente/indeferidos?page=1'} />
      </Box>

      <Box className={styles}>
        <CardServices load={loadMenu} count={menu.dgase} icone={''} nomeService={'DGA SE'} link={'/admin/dadg/expediente/area/DGA SE?page=1'} />
        <CardServices load={loadMenu} count={menu.dgssa} icone={''} nomeService={'DGS SA'} link={'/admin/dadg/expediente/area/DGS SA?page=1'} />
        <CardServices load={loadMenu} count={menu.dcitms} icone={''} nomeService={'DCITMS'} title={'Departamento de Comunição e Inovação Tecnológica e Modernização de Serviços '}  link={'/admin/dadg/expediente/area/DCITMS?page=1'} />
        <CardServices load={loadMenu} count={menu.dadg} icone={''} nomeService={'DADG'} title={'Departamento Apoio ao Director Geral'} link={'/admin/dadg/expediente/area/DADG?page=1'} />
        <CardServices load={loadMenu} count={menu.dasg} icone={''} nomeService={'DASG'} title={'Departamento Administração e Serviços Gerais'} link={'/admin/dadg/expediente/area/DASG?page=1'} />
        <CardServices load={loadMenu} count={menu.dcqmts} icone={''} nomeService={'DCQMTS'} title={'Departamento Controlo de qualidade de Medicamentos e Tecnologias de Saúde'} link={'/admin/dadg/expediente/area/DCQMTS?page=1'} />
        <CardServices load={loadMenu} count={menu.dftec} icone={''} nomeService={'DFTEC'} title={'Departamento Farmacovigilância, Tecnovigilância e Ensaios Clínicos'} link={'/admin/dadg/expediente/area/DFTEC?page=1'} />
        <CardServices load={loadMenu} count={menu.dlif} icone={''} nomeService={'DLIF'} title={'Departamento Licenciamento e Inspecção Farmacêutica'} link={'/admin/dadg/expediente/area/DLIF?page=1'} />
        <CardServices load={loadMenu} count={menu.dmts} icone={''} nomeService={'DMTS'} title={'Departamento Medicamentos e Tecnologias de Saúde'} link={'/admin/dadg/expediente/area/DMTS?page=1'} />
        {/* <CardServices load={loadMenu} count={menu.servicosGerais} icone={''} nomeService={'Serviços Gerais'} link={'/admin/dadg/expediente/area/Serviços Gerais'} /> */}

        <CardServices funcao='Director Geral' load={loadMenu} count={menu.directorGeral} icone={'/icones/expediente/directorGeral.svg'} nomeService={'Director Geral'} title={'Director Geral'} link={'/admin/dadg/expediente/area/Director Geral?page=1'} />
      </Box>


      <HeaderGestorConfigs title={'OUTROS SERVIÇOS'} />
      <Box className={styles}>
        {children}

      </Box>
    </Container>
  )
}
